export const agregarProcedimientos = (procedimientos) => ({
    type: 'SET_PROCEDIMIENTOS_FACTURA',
    payload: procedimientos,
});

export const agregarFormaPago = (pagos) => ({
    type: 'SET_FORMA_PAGOS',
    payload: pagos,
});

export const deleteFormaPago = (id) => ({
    type: 'DELETE_FORMA_PAGO',
    payload: id
});

export const deleteProcedimientoFactura = (id) => ({
    type: 'DELETE_PROCEDIMIENTO_FACTURA',
    payload: id
});

export const resetFormaPagos = () => ({
    type: 'RESET_FORMA_PAGOS'
});

export const resetProcedimientoFactura = () => ({
    type: 'RESET_PROCEDIMIENTO_FACTURA'
});

export const updateProcedimientoFactura = (procedimientos) => ({
    type: 'UPDATE_PROCEDIMIENTO_FACTURA',
    payload: procedimientos
});

export const agregarCabeceraFactura = (cabecera) => ({
    type: 'SET_CABECERA_FACTURA',
    payload: cabecera
});

export const  limpiarCabeceraFactura = (campo) => ({
    type: 'DELETE_CABECERA_FACTURA',
    payload: campo
});